import { combineReducers } from 'redux';
import popup from './popup/reducer';
import notification from './notification/reducer';
import loading from './loading/reducer';
import appSelector from '../containers/Product/Applications/store/appSelector/reducer';
import productSelector from '../containers/store/productSelector/reducer';
import moduleSelector from '../containers/Product/Modules/store/moduleSelector/reducer';
import common from '../containers/store/common/reducer';
import moduleConfiguration from '../containers/Product/Applications/store/moduleConfig/reducer';
import modules from '../containers/Product/Modules/store/modules/reducer';
import guide from '../containers/Guide/store/guide/reducer';
import organizationList from '../v2/store/organizationList/reducer';
import projectList from '../v2/store/projectList/reducer';
import projectDetail from '../v2/store/projectDetail/reducer';
import ui from '../v2/store/ui/reducer';

// Combines all reducers to a single reducer function
const reducers = combineReducers({
  common,
  productSelector,
  appSelector,
  moduleSelector,
  moduleConfiguration,
  popup,
  notification,
  loading,
  modules,
  guide,
  organizationList,
  projectList,
  projectDetail,
  ui,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
